import { Route, Routes } from "react-router-dom";
// page routes
import Home from "./components/Home/Home";
import AboutUs from "./components/about/about";
import Contact from "./components/Contact/Contact";
import Payment from "./components/Payment/Payment";
import NewsDetail from "./components/NewsDetail/NewsDetail";
import Service from "./components/Service/Service";
import AppointmentPage from "./components/Appointment/Appointment";
import SingleNews from "./components/NewsDetail/SingleNews";
import Page404 from "./components/page404/page404";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-page" element={<Contact />} />
        <Route path="/news-page" element={<NewsDetail />} />
        <Route path="/news-detail/:id" element={<SingleNews />} />
        <Route path="/services" element={<Service />} />
        <Route path="/pay-now" element={<Payment />} />
        <Route path="/appointment" element={<AppointmentPage />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </div>
  );
}

export default App;
